import './button.css'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'

export interface Props {
  href: string
  backgroundColor?: string
  children: string
}

export const LinkButton = memo(
  ({ href, backgroundColor, children, ...rest }: Props) => {
    const style = backgroundColor ? { backgroundColor } : undefined

    return (
      <ErrorBoundary
        fallback={
          <a style={style} className="link-big-button" href={href}>
            {children}
          </a>
        }
      >
        <Link style={style} className="link-big-button" to={href} {...rest}>
          {children}
        </Link>
      </ErrorBoundary>
    )
  },
)
